import colors from '@/utils/colors';
const { manColor, womanColor, officeColor, notClassifiedColor } = colors;

export default {
  data() {
    return {
      genderObj: {
        manColor,
        womanColor,
        officeColor,
        notClassifiedColor,
        manLabel: 'Homem',
        womanLabel: 'Mulher',
        officeLabel: 'Organização',
        notClassifiedLabel: 'Não Classificados',
        manValue: 1,
        womanValue: 2,
        officeValue: 3,
      },
      genders: [
        'man',
        'woman',
        'office',
      ],
    };
  },
  methods: {
    getGenderObj(title) {
      return {
        color: this.genderObj[`${title}Color`],
        name: this.genderObj[`${title}Label`],
        value: this.genderObj[`${title}Value`],
      };
    },
    getChannelColorNameAndIcon(title) {
      switch (title) {
      case 'Homem':
        return this.getGenderObj('man');

      case 'Marca':
      case 'Organização':
        return this.getGenderObj('office');

      case 'Mulher':
        return this.getGenderObj('woman');

      case 'Não Classificados':
      default:
        return this.getGenderObj('notClassified');
      }
    },
  },
};
